export type DetectedOS = 'windows' | 'macos' | 'linux' | 'unknown';

export interface DetectedPlatform {
  os: DetectedOS;
  label: string;
  detail: string;
  arch?: string;
  beta?: boolean;
}

export function detectOS(): DetectedOS {
  const ua = navigator.userAgent.toLowerCase();
  if (/windows|win32|win64/i.test(ua)) return 'windows';
  if (/mac os x|macintosh|macppc/i.test(ua)) return 'macos';
  if (/linux|x11/i.test(ua)) return 'linux';
  return 'unknown';
}

export async function detectPlatform(): Promise<DetectedPlatform> {
  const os = detectOS();
  if (os === 'windows') {
    // Un'unica build Windows copre 10 e 11 (x64): nessuna distinzione lato utente.
    return { os, label: 'Scarica per Windows', detail: 'Windows 10/11  x64', arch: 'x64' };
  }
  if (os === 'macos') {
    let arm = true;
    try {
      const uaData = navigator as unknown as { userAgentData?: { getHighEntropyValues?: (hints: string[]) => Promise<{ architecture?: string }> } };
      if (uaData.userAgentData?.getHighEntropyValues) {
        const hev = await uaData.userAgentData.getHighEntropyValues(['architecture']);
        if (hev?.architecture) arm = hev.architecture === 'arm';
      }
    } catch {
      arm = false;
    }
    const detail = arm ? 'Apple Silicon' : 'Intel';
    return { os, label: 'Scarica per macOS', detail: `${detail}  beta`, arch: arm ? 'arm64' : 'x64', beta: true };
  }
  if (os === 'linux') {
    return { os, label: 'Scarica per Linux', detail: 'AppImage  beta', arch: 'x64', beta: true };
  }
  return { os: 'unknown', label: 'Scarica App Desktop', detail: '' };
}

export interface OSInfo {
  id: string;
  name: string;
  version: string;
  arch: string;
  icon: string;
  badge?: 'recommended' | 'beta';
  downloadUrl?: string;
  placeholder?: boolean;
  disabled?: boolean;
}

export const SUPPORTED_OS: OSInfo[] = [
  { id: 'windows', name: 'Windows', version: '10/11', arch: 'x64', icon: 'windows', badge: 'recommended' },
  { id: 'macos', name: 'macOS', version: 'Sequoia+', arch: 'Apple Silicon', icon: 'apple', badge: 'beta', placeholder: true },
  { id: 'macos-intel', name: 'macOS', version: 'Sequoia+', arch: 'Intel', icon: 'apple', badge: 'beta', placeholder: true },
  { id: 'linux', name: 'Linux', version: 'Ubuntu 24+', arch: 'x64', icon: 'linux', badge: 'beta', placeholder: true },
];

export function getOSById(id: string): OSInfo | undefined {
  return SUPPORTED_OS.find(o => o.id === id);
}
